import request from '../utils/request'
const prefix = '/api/v1/back'

/**
 * 活动列表
 * @param {*} query
 */
export const promotionActivityList = (query) => {
  return request({
    url: `${prefix}/promotionActivity/list`,
    method: 'get',
    params: query
  })
}
/**
 * 活动创建
 * @param {*} query
 */
export const promotionCreate = (query) => {
  return request({
    url: `${prefix}/promotionActivity`,
    method: 'post',
    data: query
  })
}
/**
 * 活动详情
 * @param {*} query
 */
export const promotionDetail = (query) => {
  return request({
    url: `${prefix}/promotionActivity`,
    method: 'get',
    params: query
  })
}
/**
 * 活动修改
 * @param {*} query
 */
export const promotionPut = (query) => {
  return request({
    url: `${prefix}/promotionActivity`,
    method: 'put',
    data: query
  })
}
/**
 * 用户请求记录列表
 * @param {*} query
 */
export const userHttpRequestLog = (query) => {
  return request({
    url: `${prefix}/monitor/userHttpRequestLog/list`,
    method: 'get',
    params: query
  })
}

/**
 * 批量删除
 * @param {*} query
 */
export const promotionDetlete = (query) => {
  return request({
    url: `${prefix}/promotionActivity/list`,
    method: 'delete',
    data: query
  })
}


